/**
 * This is a temporary navigation context solution to let Angular do the routing.
 * REMOVE THIS WHEN ANGULAR IS GONE!
 */
import { createContext, useContext } from 'react';

export const ViewFindReceptionTempNavigationContext = createContext<{ __TEMP__onNavigate?: (route: string) => void }>({});
export function useViewFindReceptionTempNavigationContext() {
	const context = useContext(ViewFindReceptionTempNavigationContext);

	if (!context) {
		throw new Error('useViewFindReceptionTempNavigationContext must be used within a ViewFindReceptionTempNavigationProvider');
	}

	return context;
}
